import Vue from 'vue'
import Vuex from 'vuex'
import * as $53bec368 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/backdrop.ts";
import * as $2d221c16 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/cart.ts";
import * as $6dd2139c from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/coupon.ts";
import * as $2675fea4 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/downtimes.ts";
import * as $050c1f30 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/last-seen-offers.ts";
import * as $7d246b89 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/loader.ts";
import * as $d802caec from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/navigation.ts";
import * as $fc7325e6 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/offers.ts";
import * as $77d20518 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/order.ts";
import * as $4a1a7242 from "/srv/webapps/td-eg-solo-frontend/production/releases/20250716075416/store/server-date.ts";
Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

const storeModules = {
  backdrop: $53bec368,
  cart: $2d221c16,
  coupon: $6dd2139c,
  downtimes: $2675fea4,
  "last-seen-offers": $050c1f30,
  loader: $7d246b89,
  navigation: $d802caec,
  offers: $fc7325e6,
  order: $77d20518,
  "server-date": $4a1a7242
}

export function createStore() {
  let store = normalizeRoot(storeModules.root || {})
  for (const id in storeModules) {
    if (id === 'root') { continue }
    resolveStoreModules(store, storeModules[id], id)
  }
  if (typeof store === 'function') {
    return store
  }
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, id) {
  moduleData = moduleData.default || moduleData
  if (moduleData.commit) {
    throw new Error(`[nuxt] ${id} should export a method that returns a Vuex instance.`)
  }
  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = { ...moduleData }
  }
  moduleData.modules = moduleData.modules || {}
  return moduleData
}

function resolveStoreModules (store, moduleData, id) {
  moduleData = moduleData.default || moduleData

  const namespaces = id.split('/').filter(Boolean)
  let moduleName = namespaces[namespaces.length - 1]

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })
    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}


function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }
  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = { ...storeModule[property], ...moduleData }
  }
}